export const GET_USERS = "GET_USERS";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const SET_CURRENT = "SET_CURRENT";
export const CLEAR_CURRENT = "CLEAR_CURRENT";
export const UPDATE_USER = "UPDATE_USER";
export const FILTER_USERS = "FILTER_USERS";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const USER_ERROR = "USER_ERROR";
export const CLEAR_USERS = "CLEAR_USERS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const NOT_AUTHORIZED = "NOT_AUTHORIZED";
export const ADD_CLIENT = "ADD_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const FILTER_CLIENTS = "FILTER_CLIENTS";
export const CLIENT_ERROR = "CLIENT_ERROR";
export const GET_CLIENTS = "GET_CLIENTS";
export const CLEAR_CLIENTS = "CLEAR_CLIENTS";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTONS";
export const CLEAR_SUBSCRIPTIONS = "CLEAR_SUBSCRIPTONS";
export const ADD_SUBSCRIPTION = "ADD_SUBSCRIPTON";
export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTON";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTON";
export const FILTER_SUBSCRIPTIONS = "FILTER_SUBSCRIPTONS";
export const SUBSCRIPTION_ERROR = "SUBSCRIPTON_ERROR";
export const GET_DROPDOWNS = "GET_APPNAMES";
export const GET_TOUCHES = "GET_TOUCHES";
export const TOUCHES_ERROR = "TOUCHES_ERROR";
export const DELETE_TOUCH = "DELETE_TOUCH";
export const FILTER_TOUCHES = "FILTER_TOUCHES";
export const CLEAR_TOUCHES = "CLEAR_TOUCHES";
export const ADD_CLIENTANDSUBSCRIPTION = "ADD_CLIENTANDSUBSCRIPTION";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SET_CLIENT = "SET_CLIENT";
